var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daten"},[_c('Header'),_c('Hero',{attrs:{"step":"daten"}}),_c('Daten'),_c('SectionSplit'),_c('DataSummary'),_c('TicketsSummaryReservierung'),_c('Footer'),_c('SlideNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }